module.exports = __webpack_public_path__ + "de77a722/img/dollar-icon.35c9d638.svg";